import React from 'react';
import styles from "./index.module.scss";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

const EventRegistration = () => {
    const email = "connectapp@shi.org.il";
    return (
        <div className={styles.container}>
            <div className={styles.messageBox}>
                <div className={styles.iconWrapper}>
                    <InfoOutlinedIcon className={styles.icon} />
                </div>
                <h3>Not Registered</h3>
                <p>You are not currently registered to this seminar.</p>
                <div className={styles.contactInfo}>
                    <EmailOutlinedIcon className={styles.emailIcon} />
                    <p>Please contact <a href={`mailto:${email}`}>{email}</a> for support.</p>
                </div>
            </div>
        </div>
    );
}

export default EventRegistration;